<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded">
<p class="dedf"><a class="page" id="pv"></a>To Victoria, Live, Love, Laugh</p>
<p class="ded">and</p>
<p class="ded">To my late father, whose boundless legacy needs no words</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// rbgfeder0006.vue?022f45ff